import {memo} from "react";
import {Bar, Column} from '@ant-design/charts';

const ColumnCompareAbleChart = memo(({data, xAxis = 'source', yAxis = 'target', customConfig = {}}) => {

    let sortedData = [...data];
    sortedData.sort((a, b) => a.amount - b.amount )
    sortedData.reverse()

    var config = {
        data: sortedData,
        xField: xAxis,
        yField:yAxis,
        xAxis: {
            label: {
                autoHide: true,
                autoRotate: false,
            },
        },
    };
    return (
        <Column {...config} {...customConfig} />
    )
})

export default ColumnCompareAbleChart;